module.exports = {
	ColorDivider: "#d8d8d8",
	ColorBackgroundDefault: "#eeeeee",
	ColorBackgroundSecondary: "#ffffff",
	ColorPrimaryMain: "#1c365f",
	ColorPrimaryLight: "#0060ac",
	ColorPrimaryDark: "#162845",
	ColorPrimaryContrastText: "#ffffff",
	ColorTextPrimary: "#444444",
	ColorTextSecondary: "#6b6b6b",
	ColorTextDisabled: "#6e7781",
	ColorTextHint: "#0060aa",
	ColorSecondaryMain: "#f89235",
	ColorSecondaryLight: "#feefe2",
	ColorSecondaryDark: "#da782d",
	ColorSecondaryContrastText: "#ffffff",
	ColorContextualSuccessContrastText: "#ffffff",
	ColorContextualSuccessLight: "#d7e8d4",
	ColorContextualSuccessDark: "#376b49",
	ColorContextualSuccessMain: "#3faf2a",
	ColorContextualDangerMain: "#c02e21",
	ColorContextualDangerLight: "#ecd6d4",
	ColorContextualDangerDark: "#631b16",
	ColorContextualDangerContrastText: "#ffffff",
	ColorContextualWarningMain: "#f59245",
	ColorContextualWarningLight: "#feefe2",
	ColorContextualWarningDark: "#8f6b32",
	ColorContextualWarningContrastText: "#ffffff",
	ColorContextualInfoMain: "#1c365f",
	ColorContextualInfoLight: "#e0ecf5",
	ColorContextualInfoDark: "#162845",
	ColorContextualInfoContrastText: "#ffffff",
	ColorContextualDefaultMain: "#889099",
	ColorContextualDefaultLight: "#cacfd4",
	ColorContextualDefaultDark: "#6e7781",
	ColorContextualDefaultContrastText: "#ffffff",
	ColorActionActive: "#444444",
	ColorActionHover: "#0060ac",
	ColorActionSelected: "#c2d8e7",
	ColorActionDisabled: "#6e7781",
	SpacingXxs: "6",
	SpacingXs: "8",
	SpacingSm: "12",
	SpacingMd: "16",
	SpacingLg: "24"
};